const MagistratMapMandataireListStyle = {
  height: "100%",
  width: "600px",
};

export { MagistratMapMandataireListStyle };
